import { useQuery } from "@tanstack/react-query";
import { fetchOrgSubscription } from "@/api/subscriptions";

/**
 * One organization's subscription and its billing history.
 *
 * GFG-only by the route's own gate (`view TIER @ all`), so a client role simply gets a 403 and the
 * tab it backs is never rendered for them.
 */
export function useOrgSubscription(organizationId: number) {
  return useQuery({
    queryKey: ["orgSubscription", organizationId],
    queryFn: () => fetchOrgSubscription(organizationId),
    enabled: Number.isInteger(organizationId),
  });
}
